/**
 * What the reset screen says when a reset fails - in the household's
 * language, not the server's English. (V18.96)
 *
 * The server sends a short code; this picks the message for it. A server one
 * release behind still sends its old English sentences, so those are
 * recognised by their words too, and anything unrecognised gets the plain
 * "something went wrong" message rather than raw text.
 */
export function resetErrorKey(err) {
  const status = err && err.response && err.response.status;
  const detail = err && err.response && err.response.data && err.response.data.detail;
  if (status === 429) return 'reset.errTooMany';
  const d = typeof detail === 'string' ? detail : '';
  if (d === 'reset_used' || /already been used/i.test(d)) return 'reset.errUsed';
  if (d === 'reset_expired' || /expired/i.test(d)) return 'reset.errExpired';
  if (d === 'weak_password') return 'reset.fixRequirements';
  if (d === 'reset_invalid' || /invalid reset token|user not found/i.test(d)) return 'reset.errInvalid';
  return 'reset.errFailed';
}
